var _g, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOperationsAiCamera(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 54,
    viewBox: "0 0 48 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_193_4509)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.3608 7.12573C33.0292 3.79414 28.5978 1.96338 23.8883 1.96338C19.1723 1.96338 14.7475 3.79414 11.4159 7.12573C8.0843 10.4573 6.24707 14.8887 6.24707 19.5982C6.24707 29.1272 15.2585 37.0583 20.1039 41.315C20.7767 41.9101 21.3524 42.4212 21.8182 42.8481C22.4004 43.3915 23.1444 43.6632 23.8883 43.6632C24.6323 43.6632 25.3762 43.3915 25.952 42.8481C26.4177 42.4212 27 41.9101 27.6728 41.315C32.5116 37.0583 41.5231 29.1272 41.5231 19.5982C41.5231 14.8887 39.6924 10.4573 36.3608 7.12573Z",
    fill: "#E0791A",
    stroke: "white",
    strokeWidth: 3,
    strokeMiterlimit: 22.9256
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.6658 18.1397L21.5605 11.5726C21.1973 11.4051 20.7662 11.5613 20.597 11.9224L17.6655 18.1983C17.5841 18.3722 17.5756 18.5715 17.6414 18.7517C17.7073 18.9319 17.8418 19.079 18.0159 19.1603L20.1829 20.1692L19.4318 21.7777C19.3504 21.9515 19.3419 22.1508 19.4077 22.331C19.4736 22.5113 19.608 22.6583 19.7822 22.7396L21.1048 23.3554L19.3808 27.047H17.2379V25.4772C17.2379 25.077 16.9137 24.7533 16.513 24.7533C16.1123 24.7533 15.7881 25.077 15.7881 25.4772V30.063C15.7881 30.463 16.1123 30.7868 16.513 30.7868C16.9137 30.7868 17.2379 30.463 17.2379 30.063V28.4945H19.8424C20.1241 28.4945 20.3804 28.3312 20.4993 28.0768L22.4189 23.967L23.7373 24.5809C23.8365 24.6269 23.9406 24.6488 24.0432 24.6488C24.3165 24.6488 24.5777 24.4939 24.7009 24.231L25.452 22.6225L29.6903 24.5957C29.7893 24.6417 29.8935 24.6636 29.9961 24.6636C30.2693 24.6636 30.5306 24.5088 30.6538 24.2459L30.7661 24.0052L32.5404 24.8311C32.6394 24.877 32.7436 24.8989 32.8462 24.8989C33.1194 24.8989 33.3807 24.7442 33.5039 24.4812L35.1788 20.8948C35.348 20.5322 35.1909 20.1018 34.8284 19.9328L34.563 19.8092L35.5802 19.4847C35.8641 19.3943 36.0637 19.1391 36.0828 18.8415C36.102 18.544 35.9363 18.2654 35.6658 18.1397ZM33.3729 18.6697L31.9309 19.1299L21.1704 14.1199L21.6044 13.1904L33.3729 18.6697ZM31.3793 22.6936L32.2784 20.7673C32.3213 20.6796 32.3949 20.4434 32.5277 20.4586L33.5583 20.9386L32.4964 23.2132L31.3793 22.6936Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_193_4509",
    x: 0.74707,
    y: 0.463379,
    width: 46.2759,
    height: 52.6997,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_193_4509"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_193_4509",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOperationsAiCamera);
export default __webpack_public_path__ + "static/media/operationsAICamera.693134a682098792b844b5bf8ba579ae.svg";
export { ForwardRef as ReactComponent };